import {Component, Input} from '@angular/core';
import {TileType23_24} from "../../../models";
import {
    ParametersService,
    SubtitlesService,
    TilesService,
} from "../../../core";

@Component({
    selector: 'tile-additional-valve',
    templateUrl: './tile-additional-valve.component.html',
    styleUrls: ['./tile-additional-valve.component.scss']
})
export class TileAdditionalValveComponent {
    @Input() tile: TileType23_24;

    constructor(
        private parameters: ParametersService,
        public subtitles: SubtitlesService,
        private tiles: TilesService,
    ) {
    }

    subtitle(val: number): string {
        return this.subtitles.setSubtitle(val);
    }

    getIconName() {
        return this.parameters.urlCompany === 'klimor' ? 'setting-klimor': 'setting'
    }

    getSetTemp() {
        return this.tile.params.setTemp + this.tile.params.setTempCorrection;
    }

    openSubmenu() {
        this.tiles.openSubmenu(this.tile.elementMenu);
    }
}
